<template>
  <m-dialog ref="dlg" @save="save" :title="isEdit ? 'Kelola Modul' : 'Tambah Organisasi'">
    <div class="mt-3">
      <template v-if="isEdit">
        <v-row>
          <v-col cols="12" sm="6" md="10" lg="10" offset="2">
            <span class="primary--text font-weight-bold">
              {{ getDeepObj(detail, 'label.label') || 'Blokir Fitur Pembayaran Finnet' }}
            </span>
            <p
              class=""
              v-html="
                `${getDeepObj(detail, 'label.deskripsi') ||
                  'Jika dipilih<strong>YA</strong>, Maka menu pembayaran finnet tidak akan muncul'}`
              "
            >
            </p>
            <v-radio-group v-model="form[detail.key || 'is_blokir_finpay']" row>
              <v-radio label="Ya" value="1"></v-radio>
              <v-radio label="Tidak" value="0"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row row wrap justify="center" align="center">
          <v-col cols="12" sm="10" md="8" lg="8">
            <v-row dense>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="siapId"
                  dense
                  outlined
                  placeholder=""
                  label="Kode Siap ID"
                  append-icon="mdi-magnify"
                  @keydown.enter="getOrgsSimpatika"
                ></v-text-field>
              </v-col>
              <template v-if="Object.keys(organisasi).length">
                <v-col cols="12" md="6" lg="6" sm="12">
                  <span class="primary--text">Nama Organisasi</span>
                  <v-text-field
                    dense
                    outlined
                    placeholder=""
                    readonly
                    :value="organisasi.nama"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6" sm="12">
                  <span class="primary--text">Pilih Tenant</span>
                  <v-select
                    v-model="organisasi.kode_tenant"
                    dense
                    outlined
                    placeholder="Pilih Tenant"
                    item-text="nama"
                    item-value="no_reg"
                    :items="tenants"
                  >
                    <template v-slot:item="{ item }">
                      {{ item.nama }} &nbsp; <span class="grey--text caption"> ({{ item.no_reg }})</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="6" lg="6" sm="12">
                  <span class="primary--text">Kota</span>
                  <v-text-field
                    dense
                    outlined
                    placeholder=""
                    readonly
                    :value="organisasi.kota"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6" sm="12">
                  <span class="primary--text">Provinsi</span>
                  <v-text-field
                    dense
                    outlined
                    placeholder=""
                    readonly
                    :value="organisasi.propinsi"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" lg="12" sm="12">
                  <span class="primary--text">Alamat</span>
                  <v-textarea
                    dense
                    outlined
                    placeholder=""
                    readonly
                    :value="organisasi.alamat"
                  ></v-textarea>
                </v-col>
              </template>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </div>
  </m-dialog>
</template>
<script>
export default {
  props: {
    tenants: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      detail: {},
      dialog: false,
      keyword: '',
      form: {},
      isEdit: true,
      siapId: '',
      organisasi: {}
    }
  },
  methods: {
    open(obj) {
      this.reset()
      this.detail = obj || {}
      this.isEdit = obj.isEdit
      this.initForm(obj)
      this.$nextTick(() => {
        this.$refs.dlg.open()
      })
    },

    initForm(obj) {
      if (obj && obj.konfigurasi) {
        this.$set(this.form, obj.key, obj.konfigurasi.value)
      }
    },

    reset() {
      this.detail = {}
      this.form = {}
      this.siapId = null
      this.organisasi = {}
    },

    getOrgsSimpatika() {
      if (this.siapId) {
        this.$store.dispatch('akses/getSimpatika', this.siapId).then(({ data }) => {
          this.organisasi = data.data.data || data.data || data || {}
        })
      }
    },

    save() {
      if (this.isEdit) {
        const key = (this.detail && this.detail.key) || 'is_blokir_finpay'
        const orgs = [this.detail && this.detail.organisasi && this.detail.organisasi.organisasi_id]

        this.$store
          .dispatch('akses/saveCfg', {
            key: key,
            value: this.form[key],
            organisasi_ids: orgs,
          })
          .then(() => {
            this.$success('Konfigurasi berhasil di perbarui')
            this.$emit('reload')
            this.$refs.dlg.resolve()
          })
      } else {
        if (!Object.keys(this.organisasi).length || !this.organisasi.kode_tenant) {
          this.$error('Harap Lengkapi Data Organisasi')
          return
        } else {
          this.$store
            .dispatch('akses/saveOrgs', {
              kode_tenant: this.organisasi.kode_tenant,
              data_id: this.organisasi.siap_id,
            })
            .then(() => {
              this.$success('Organisasi berhasil ditambahkan')
              this.$emit('reload')
              this.$refs.dlg.resolve()
            })
        }
      }
    },
  },
}
</script>
